export default "__VITE_ASSET__f8769588__"